<template>
  <rank-division-pick
    :type="'currentRank'"
    item-key="winBoosting"
    :title="$t('calculators_common.current_rank')"
    class="full-width"
  />
  <RangePicker
    :title="$t('calculators_common.number_of_wins')"
    :description="$t('calculators_common.select_number_of_wins')"
    type="wins-over"
    :max="5"
  />
  <ExtraOptionPicker />
  <PlatformPicker />
  <OptionPicker />
  <RolesPicker :select-only-one-role="true" :max1="true" />
  <ChampionsPicker />
</template>

<script setup>
import RankDivisionPick from "./pickers/RankDivisionPicker.vue";

import OptionPicker from "./pickers/OptionPicker.vue";
import RolesPicker from "../lol/pickers/RolesPicker.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import RangePicker from "../commonpickers/RangePicker.vue";
import PlatformPicker from "../commonpickers/PlatformPicker.vue";
import ChampionsPicker from "../commonpickers/ChampionsPicker.vue";

const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();
  checkoutStore.setOneRole({
    roleId: gameStore.getGame.roles[0]?.id,
  });
  if (gameStore.getGameRanks?.length > 0) {
    const currentRank = gameStore.getGameRanks[0];
    checkoutStore.setDetails({
      currentDivision: currentRank.divisions[0]?.id,
      currentDivisionTitle: currentRank.divisions[0]?.title,
      currentRank: currentRank.id,
      currentRankTitle: currentRank.title,
      numberOfWins: 1,
    });
  }
  checkoutStore.setServer(gameStore.getGame.servers[0]?.id);
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};

handleDetails();
onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
